<template>
  <div>
    <div class="pay-tips warning" v-if="isSandBox">
      <div class="tips-ico"></div>
      <div class="tips-text">此页面作测试用。不可进行实际支付。</div>
    </div>
    <div class="pay-prompt">{{ letter.howToPay }}</div>

    <div class="payment-wrap" id="payment-form">
      <div
        class="payway-item"
        v-for="(payType, index) in user_pay_infos"
        :key="payType.KEY_VALUE"
        @click.capture="changePayway(payType)"
      >
        <div
          class="payway-row j-payway-item"
          :pointValue="payType.KEY_DESC"
          :class="{ active: active_payway === payType.KEY_VALUE }"
        >
          <div class="left">
            <div class="payment-radio"></div>
            <div class="payment-icon" :class="payType.KEY_DESC"></div>
            <div class="payment-name">
              •••• {{ payType.KEY_VALUE_DESC.slice(-4) }}
            </div>
          </div>
          <div
            class="delete-action j-delete-action"
            @click.stop="setDeleteRowShow(true)"
          >
            {{ letter.del }}
          </div>
        </div>
        <template v-if="active_payway === payType.KEY_VALUE">
          <div class="delete-row" v-if="showDeleteRow">
            <div class="delete-text">{{ letter.deleteCardTips }}</div>
            <div class="delete-btn-group">
              <div
                class="go-delete j-go-delete"
                @click.stop="deleteConfirm(payType)"
              >
                {{ letter.confirmDelete }}
              </div>
              <div
                class="cancel j-delete-cancel"
                @click.stop="setDeleteRowShow(false)"
              >
                {{ letter.eventCancel }}
              </div>
            </div>
          </div>
          <div class="payway-detail">
            <template v-if="!isWPOrAliPay">
              <div class="detail-row expire-and-code">
                <div
                  class="expire-item"
                  v-if="payType.CONTENT && payType.CONTENT.expiry_month"
                >
                  <div class="detail-label">{{ letter.expireTime }}</div>
                  <div
                    class="expire-input short-input input-item disable-expire-div"
                  >
                    {{ payType.CONTENT.expiry_month }} /
                    {{ payType.CONTENT.expiry_year }}
                  </div>
                </div>
                <div class="code-item">
                  <div class="detail-label" v-if="!isCKO || checkoutCvvLoading">
                    {{ letter.CVV }}
                  </div>
                  <template v-if="isCKO">
                    <div class="checkout-cvv-field">
                      <div
                        v-show="checkoutCvvLoading"
                        class="checkout-cvv-loading"
                        aria-busy="true"
                        aria-live="polite"
                      >
                        <div class="checkout-cvv-loading__spiral">
                          <div class="checkout-cvv-loading__spiral-item"></div>
                        </div>
                      </div>
                      <div id="checkout-cvv-container"></div>
                    </div>
                  </template>
                  <template v-else>
                    <input
                      class="code-input short-input input-item"
                      placeholder="CVV"
                      v-model="cvv"
                      type="text"
                      @input="checkCVV"
                      @focus="focusCVV"
                    />
                  </template>
                  <div class="error-tips" v-if="errorCodeTips">
                    {{ letter.checkCVV }}
                  </div>
                </div>
              </div>
            </template>

            <div
              class="pay-btn j-pay-btn"
              id="pay-button"
              @click="submitPay(payType)"
              :class="{ loading: showLoading }"
            >
              <span class="lock-icon"></span>
              <span class="pay-text"
                >{{ letter.neddPay }} {{ getMoneyWithUnit }}</span
              >
              <div class="spiral" v-if="showLoading">
                <div class="spiral-item"></div>
              </div>
            </div>
          </div>
        </template>
      </div>
      <AddCard></AddCard>
    </div>
    <PopupWindow
      v-if="showErrorPopup"
      type="tips"
      :languages="letter"
      :content="errorMessage"
      textAlign="center"
      @onConfirm="handleErrorPopupClose"
      @onCancel="handleErrorPopupClose"
    ></PopupWindow>
  </div>
</template>

<script>
import AddCard from './AddCard';
import { mapState, mapGetters } from 'vuex';
import {
  SET_ACTIVE_PAYWAY,
  PAYMENT_REQUEST_ACTION,
  DELETE_PAY_TYPE_ACTION
} from '@store/officialTopupNew/cash';
import { clickButton } from '@plugins/biPoint/_configWebstoreV35';
import checkoutFlowMixin from '@mixins/officialTopupNew/checkoutFlow';

export default {
  mixins: [checkoutFlowMixin],
  data() {
    return {
      showDeleteRow: false,
      errorCodeTips: false,
      cvv: '',
      showLoading: false,
      showDeleteLoading: false
    };
  },
  components: {
    AddCard
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      user_pay_infos: state => state.cash.user_pay_infos,
      active_payway: state => state.cash.active_payway,
      public_key: state => state.cash.public_key,
      lang: state => state.lang
    }),
    ...mapGetters(['isWPOrAliPay', 'isSandBox', 'getMoneyWithUnit', 'isCKO'])
  },
  watch: {
    active_payway: {
      handler(val) {
        if (
          this.isCKO &&
          !this.isWPOrAliPay &&
          val &&
          val !== 'addCard' &&
          this.user_pay_infos.some(p => p.KEY_VALUE === val)
        ) {
          this.$nextTick(() => {
            this.initCheckoutCvv(val);
          });
        }
      },
      immediate: true
    }
  },
  methods: {
    changePayway(payway) {
      if (payway.KEY_VALUE !== this.active_payway) {
        window.webstorev35DataLayer.push({
          eventName: 'select_credit',
          eventType: 'saved_credit_card',
          eventValue: {
            credit_type: payway.KEY_DESC
          }
        });
      }
      this.$store.commit(SET_ACTIVE_PAYWAY, payway.KEY_VALUE);
      this.showDeleteRow = false;
    },
    focusCVV() {
      window.webstorev35DataLayer.push({
        eventName: 'input_cardinfo',
        eventType: 'saved_credit_card',
        eventReason: 'cvv'
      });
    },
    setDeleteRowShow(state) {
      clickButton({
        btnName: state ? 'delete_card_ask' : 'cancel_delete'
      });
      this.showDeleteRow = state;
    },
    checkCVV() {
      if (this.isWPOrAliPay) {
        return true;
      }
      const cvvReg = /^\d{3,4}$/;
      const passReg = cvvReg.test(this.cvv);
      this.errorCodeTips = !passReg;
      return passReg;
    },
    async deleteConfirm(data) {
      clickButton({
        btnName: 'confirm_delete_card'
      });
      const commitData = {
        key_value: data.KEY_VALUE
      };
      this.showDeleteLoading = true;
      await this.$store.dispatch(DELETE_PAY_TYPE_ACTION, commitData);
      this.showDeleteLoading = false;
    },
    async submitPay(data) {
      if (this.showLoading) {
        return;
      }

      const commitData = {
        source_type: 'id',
        key_value: data.KEY_VALUE
      };

      // WP不需要CVV
      if (!this.isWPOrAliPay) {
        if (this.isCKO) {
          const cvvToken = await this.tokenizeCvv();
          if (!cvvToken) {
            return;
          }
          commitData.cvv = cvvToken;
        } else {
          if (!this.checkCVV()) {
            return;
          }
          commitData.cvv = this.cvv;
        }
      }

      this.showLoading = true;
      clickButton({
        btnName: 'click-pay-btn'
      });
      await this.$store.dispatch(PAYMENT_REQUEST_ACTION, commitData);
    }
  }
};
</script>
